import { animate, state, style, transition, trigger } from '@angular/animations';
import { CBAnimationCurves, CBAnimationDurations } from '@core/animations/defaults';

// -----------------------------------------------------------------------------------------------------
// @ Expand / collapse
// -----------------------------------------------------------------------------------------------------
const expandCollapse = trigger('expandCollapse',
    [
        state('void, collapsed',
            style(
                {
                    height: '0px',
                    opacity: 0,
                    visibility: 'hidden'
                }
            )
        ),

        state('*, expanded',
            style(
                {
                    height: '*',
                    opacity: 1,
                    visibility: 'visible'
                }
            )
        ),

        // Prevent the transition if the state is false
        transition('void <=> false, collapsed <=> false, expanded <=> false', []),

        // Transition
        transition('void <=> *, collapsed <=> expanded',
            animate('{{timings}}', ),
            {
                params: {
                    timings: `${CBAnimationDurations.entering} ${CBAnimationCurves.deceleration}`
                }
            }
        )
    ]
);

export { expandCollapse };
